<mat-card appearance="outlined" *ngIf="selectedPack">
  <mat-card-header>
    <mat-card-title>{{ 'packsTexts.orderReview' | translate }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="container">
    <div class="row">
      <!-- Пакет и удостоверение -->
      <div class="col-12 col-xl-6">
        <div class="container">

          <div class="row">
            <div class="col-2"></div>
            <div>
              <h2 class="pack-heading">{{ 'packsTexts.choosenPack' | translate }}</h2>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-5 col-md-4 tar">
              <strong>{{ 'packsTexts.packName' | translate }}:</strong>
            </div>
            <div class="col text-left">{{ selectedPack.name[lang] }}</div>
          </div>

          <div class="row">
            <div class="col-sm-5 col-md-4 tar">
              <strong>{{ 'packsTexts.description' | translate }}:</strong>
            </div>
            <div class="col text-left">
              {{ selectedPack.description[lang] }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-5 col-md-4 tar">
              <strong>{{ 'packsTexts.validity' | translate }}:</strong>
            </div>
            <div class="col text-left">
              {{ validityText }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-5 col-md-4 tar">
              <strong>{{ 'common.price' | translate }}:</strong>
            </div>
            <div class="col text-left">
              <ng-container *ngIf="selectedPack?.currencyCode">
                <span [ngClass]="{ 'hide': selectedPack.currencyCode === 'EUR' }"
                  *ngIf="selectedPack.currencyCode === 'BGN'">
                  {{ selectedPack.price | localizedCurrency }} / {{ (selectedPack.price / 1.95583) | currency:'EUR':'symbol':'1.2-2':'de-DE' }}
                </span>
                <span *ngIf="selectedPack.currencyCode === 'EUR'">
                  {{ selectedPack.price | currency:'EUR':'symbol':'1.2-2':'de-DE'}} / {{ (selectedPack.price * 1.95583) | currency:'BGN':'symbol':'1.2-2':'bg-BG' }}
                </span>
              </ng-container>
            </div>
          </div>
          <br>

        </div>
      </div>

      <!-- Данни за фактура -->
      <div class="col-12">
        <br>
        <mat-divider></mat-divider>
        <br>

        <div class="container">
          <div class="row">
            <div class="col-12">
              <cloud-invoice-form #invoiceFormComponent [userData]="userData" [countryCodes]="countryCodes"></cloud-invoice-form>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button matStepperPrevious>{{'paginator.back' | translate}}</button>
    <button mat-raised-button 
            (click)="makeOrder()" 
            color="primary"  
            [disabled]="this.invoiceFormComponent.isDisableCreateOrderButton">
            {{'packsTexts.makeOrder' | translate}}
    </button>
  </mat-card-actions>
</mat-card>